import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _EmployeeContractType, _InfoForTaxReporting } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { ValueTypeSelector } from "../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";


export const InfoForTaxReporting = () => {

    const { instance, bean, setBean, lista, setLista, handleChange } = useDataBean(_InfoForTaxReporting);
    const single = Singleton.getInstance();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        instance.getInfoForTaxReportingCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const create = () => {
        setBean({});
        setModal({ ...modal, "view": true, name: "Agregar Estructura de información" });
    }
    const deleteItem = () => {
        instance.deleteInfoForTaxReporting(bean.IDInfoForTaxReporting).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => { toast.error(err) })

    }
    const editaItem = () => {
        if (!bean.SheetName) {
            toast.warning("Debe proporcionar una Hoja.");
            return;
        }
        if (!bean.ColumnName) {
            toast.warning("Debe proporcionar una Columna.");
            return;
        }
        if (!bean.ColumnIndex) {
            toast.warning("Debe proporcionar un Índice Columna.");
            return;
        }
        instance.updateInfoForTaxReporting(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDInfoForTaxReporting', visible: true },
        { title: 'Hoja', property: 'SheetName', visible: true },
        { title: 'Columna', property: 'ColumnName', visible: true },
        { title: 'Índice Columna', property: 'ColumnIndex', visible: true },
        { title: 'Valor por Defecto', property: 'DefaultValue', visible: true },
        { title: 'Tipo', property: 'ValueTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.ColumnName}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Estructura de Información Exógena">
            <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

            <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Hoja</label>
                        <input type="text" name="SheetName" className="form-control" value={bean.SheetName} onChange={(e) => { setBean({ ...bean, SheetName: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Columna</label>
                        <input type="text" name="ColumnName" className="form-control" value={bean.ColumnName} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Índice Columna</label>
                        <input type="number" name="ColumnIndex" className="form-control" value={bean.ColumnIndex} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor por Defecto</label>
                        <input type="text" name="DefaultValue" className="form-control" value={bean.DefaultValue} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <ValueTypeSelector idSelector={bean.ValueType} onChange={(e) => { setBean({ ...bean, "ValueType": e }) }} />
                    </div>
                </div>
            </Modal>

            <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                <strong>Eliminar item {bean.ColumnName}</strong>
            </ModalConfirm>
        </BasicPage>
    )
}